"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withToggle = withToggle;

var _preact = _interopRequireWildcard(require("preact"));

var _settings = require("../../constants/settings");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// import { querySelectorAllShadows } from '../../utils/html.utils';
// Allow to turn component on/off via query params
function withToggle(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      var urlParams = new URLSearchParams(window.location.search);
      var metanav = urlParams.get(_settings.TOGGLE_PARAM_NAME);

      if (metanav === _settings.TOGGLE_PARAM_VALUE || sessionStorage.getItem(_settings.TOGGLE_STORAGE_KEY)) {
        _this.state = {
          render: false
        };
        sessionStorage.setItem(_settings.TOGGLE_STORAGE_KEY, _settings.TOGGLE_STORAGE_VALUE); // if (this.props.webcomponent) {
        //   // Fix it for async renderers (or slow!!) that don't trigger this function.
        //   const intervals = [10, 50, 100, 250, 500, 1000, 1500, 2000, 3000, 5000, 7500, 10000];
        //   intervals.forEach(interval => {
        //     setTimeout(() => {
        //       const metanavs = ['mtn-header', 'mtn-footer'];
        //       metanavs.forEach(m => {
        //         const allMetanavs = querySelectorAllShadows(m);
        //         for (let index = 0; index < allMetanavs.length; index++) {
        //           const element = allMetanavs[index];
        //           const children = (element && element.children) || [];
        //           for (let i = 0; i < children.length; i++) {
        //             const child = children[index];
        //             child && child.remove && child.remove();
        //           }
        //         }
        //       });
        //     }, interval);
        //   });
        // }
      } else {
        _this.state = {
          render: true
        };
      }

      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var shouldRender = this.state.render && sessionStorage.getItem(_settings.TOGGLE_STORAGE_KEY) !== _settings.TOGGLE_STORAGE_VALUE;

        return shouldRender ? (0, _preact.h)(WrappedComponent, this.props) : null;
      }
    }]);

    return _class;
  }(_preact.Component);
}